import { css } from 'styled-components'

export const types = css`
	h1,
	h2,
	h3 {
		margin-top: 20px;
		margin-bottom: 10px;
	}

	p {
		margin: 0 0 10px;
	}

	small {
		font-size: ${({ theme }) => theme.font.size.baseSmall};
	}

	ol,
	ul {
		margin-top: 0;
		margin-bottom: 20px;
		padding-left: 24px;

		li {
			padding-left: 8px;
		}

		ol,
		ul {
			margin-bottom: 0;
		}
	}

	dl {
		margin-top: 0;
		margin-bottom: 20px;
	}

	dd,
	dt {
		line-height: 1.428571429;
	}

	dt {
		font-weight: bold;
	}

	dd {
		margin-left: 0;
	}

	strong {
		font-weight: 600;
	}
`
